<template>
	<b-modal ref="mdlRsaPazientePrescrizioneFarmacoEditModalComponent" size="xl" style="height: 100%"
		:okDisabled="disabeConferma" title="" @ok="onOk" @shown="onShown" @hide="onHideModal">
		<template #modal-title>Prescrizione Farmaco</template>
		<div class="sa-flexbox-pianificazione-modal">
			<div class="sa-tab-scroll">
				<div class="sa-flexbox-pianificazione-modal-header">
					<div>
						<b-row>
							<b-col cols="12" sm="12" md="4" lg="4" xl="2">
								<label class="sa-label-data">Data Inizio:</label>
								<b-input-group class="mb-3">
									<date-picker format="DD-MM-YYYY" value-type="timestamp"
										v-model="jsonData.dataInizio" type="search"></date-picker>
								</b-input-group>
							</b-col>
							<b-col cols="12" sm="12" md="4" lg="4" xl="2">
								<label class="sa-label-data">Data Fine:</label>
								<b-input-group class="mb-3">
									<date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="jsonData.dataFine"
										type="search"></date-picker>
								</b-input-group>
							</b-col>
							<b-col cols="6" xs="12" sm="12" md="4" lg="4" xl="3">
								<label class="sa-label-data">Nome Farmaco:</label>
								<b-input-group class="mb-3">
									<b-form-input maxlength="16" class="text-uppercase" v-model="jsonData.prescrizione"
										placeholder="Nome Farmaco" disabled></b-form-input>
									<b-button size="sm" variant="" @click="onClickOpenRicercaFarmaco">
										<b-icon icon="search"></b-icon>
									</b-button>
								</b-input-group>
							</b-col>
							<b-col cols="6" xs="12" sm="12" md="4" lg="4" xl="2">
								<label class="sa-label-data">Forma Farmaceutica:</label>
								<b-input-group class="mb-3">
									<b-form-input class="text-uppercase" v-model="jsonDataParams.formaFarmaceutica"
										placeholder="Forma Farmaceutica" disabled></b-form-input>
								</b-input-group>
							</b-col>
							<b-col cols="6" xs="12" sm="12" md="2" lg="4" xl="1">
								<label class="sa-label-data">Dose:</label>
								<b-form-input type="number" min="0" step="0.1" class="text-uppercase"
									v-model="jsonDataParams.quantita" placeholder="Dose"></b-form-input>
							</b-col>
							<b-col cols="6" xs="12" sm="12" md="2" lg="4" xl="2">
								<label class="sa-label-data">Unità di Misura:</label>
								<b-form-select v-model="jsonDataParams.unitaMisura" value-field="value"
									text-field="text" value="null" class="mb-2 mr-sm-2 mb-sm-0"
									:options="unitaMisureOptions"></b-form-select>
								<!-- <b-form-input maxlength="16" class="text-uppercase" v-model="jsonDataParams.unitaMisura" placeholder="Unità di Misura" disabled></b-form-input> -->
							</b-col>
						</b-row>
					</div>
				</div>
				<div class="sa-flexbox-pianificazione-modal-body">
					<div style="flex: 1; padding-right: 5px; display: flex; flex-direction: column">
						<label class="sa-label-data">Opzioni:</label>
						<b-row
							style="border: 1px solid rgb(204, 204, 204); width: 100%; height: 100%; margin-left: 0px; padding-top: 20px">
							<b-col cols="6" xs="12" sm="12" md="1" lg="6" xl="4">
								<b-form-checkbox switch v-model="jsonDataParams.alBisogno">Al Bisogno</b-form-checkbox>
							</b-col>
							<b-col cols="6" xs="12" sm="12" md="1" lg="6" xl="4">
								<b-form-checkbox switch v-model="jsonDataParams.salvavita">Salvavita</b-form-checkbox>
							</b-col>
							<b-col cols="6" xs="12" sm="12" md="1" lg="6" xl="4">
								<b-form-checkbox switch v-model="jsonDataParams.obbligoNota">Obbligo
									Nota</b-form-checkbox>
							</b-col>
							<b-col cols="6" xs="12" sm="12" md="1" lg="6" xl="4">
								<b-form-checkbox switch v-model="jsonDataParams.misuraPressione">Misura
									Pressione</b-form-checkbox>
							</b-col>
							<b-col cols="6" xs="12" sm="12" md="1" lg="6" xl="4">
								<b-form-checkbox switch v-model="jsonDataParams.misuraGlicemia">Misura
									Glicemia</b-form-checkbox>
							</b-col>
							<b-col cols="6" xs="12" sm="12" md="1" lg="6" xl="4">
								<b-form-checkbox switch
									v-model="jsonDataParams.modificabile">Modificabile</b-form-checkbox>
							</b-col>
							<b-col cols="6" xs="12" sm="12" md="1" lg="6" xl="4">
								<b-form-checkbox switch v-model="jsonDataParams.caricoPaziente">A carico del
									paziente/cargiver</b-form-checkbox>
							</b-col>
							<b-col cols="6" xs="12" sm="12" md="1" lg="6" xl="4">
								<b-form-checkbox switch v-model="jsonDataParams.terapiaPsichiatrica">Terapia
									Psichiatrica</b-form-checkbox>
							</b-col>
						</b-row>
					</div>
					<div
						style="flex: 1; height: 100%; background-color: transparent; overflow: hidden; display: flex; flex-direction: column">
						<label class="sa-label-data">Indicazioni:</label>
						<vue-editor class="sa-qeditor" :editor-toolbar="customToolbar" v-model="jsonData.note" />
					</div>
				</div>
				<div class="sa-flexbox-pianificazione-modal-footer">
					<div style="display: block; background-color: transparent">
						<b-tabs id="tabsRsaAree" ref="tabsRsaAree" v-model="activeTabIndex" content-class="mt-3"
							class="sa-tab" style="height: 100%" fill>
							<b-tab title="Orario">
								<rsa-pianificazione-edit-orario ref="cmpRsaPianificazioneEditOrario"
									@afterMounted="onAfterMountedRsaPianificazioneEditOrario"
									@updatePianificazioneOrario="onUpdatePianificazioneOrario"></rsa-pianificazione-edit-orario>
							</b-tab>
							<b-tab title="Turni">
								<rsa-pianificazione-edit-turni ref="cmpRsaPianificazioneEditTurni"
									@afterMounted="onAfterMountedRsaPianificazioneEditTurni"
									@updatePianificazioneTurni="onUpdatePianificazioneTurni"></rsa-pianificazione-edit-turni>
							</b-tab>
							<b-tab title="Ore Alternate">
								<rsa-pianificazione-edit-ore-alternate ref="cmpRsaPianificazioneEditOreAlternate"
									@afterMounted="onAfterMountedRsaPianificazioneEditOreAlternate"
									@updatePianificazioneOreAlternate="onUpdatePianificazioneOreAlternate"></rsa-pianificazione-edit-ore-alternate>
							</b-tab>
							<b-tab title="Giorni Alternati">
								<rsa-pianificazione-edit-giorni-alternati ref="cmpRsaPianificazioneEditGiorniAlternati"
									@afterMounted="onAfterMountedRsaPianificazioneEditGiorniAlternati"
									@updatePianificazioneGiorniAlternati="onUpdatePianificazioneGiorniAlternati"></rsa-pianificazione-edit-giorni-alternati>
							</b-tab>
							<b-tab title="Giorni del Mese">
								<rsa-pianificazione-edit-giorni-mese ref="cmpRsaPianificazioneEditGiorniMese"
									@afterMounted="onAfterMountedRsaPianificazioneEditGiorniMese"
									@updatePianificazioneGiorniMese="onUpdatePianificazioneGiorniMese"></rsa-pianificazione-edit-giorni-mese>
							</b-tab>
							<b-tab title="Accessi" :disabled="tabAccessiDisabled">
								<rsa-pianificazione-edit-accessi ref="cmpRsaPianificazioneEditAccessi"
									@afterMounted="onAfterMountedRsaPianificazioneEditAccessi"
									@updatePianificazioneAccessi="onUpdatePianificazioneAccessi"></rsa-pianificazione-edit-accessi>
							</b-tab>
						</b-tabs>
					</div>
				</div>
				<banca-farmaci-ricerca-farmaco-component ref="cmpBancaFarmaciRicercaFarmacoComponent"
					@confermaSelezione="onConfermaSelezioneBancaFarmaciRicercaFarmacoComponent"
					@annullaSelezione="onAnnullaSelezioneBancaFarmaciRicercaFarmacoComponent"></banca-farmaci-ricerca-farmaco-component>
			</div>
		</div>
	</b-modal>
</template>

<script>
import DatePicker from "vue2-datepicker";
import RsaPianificazioneEditAccessi from "../../components/pianificazione/RsaPianificazioneEditAccessi.vue";
import RsaPianificazioneEditTurni from "../../components/pianificazione/RsaPianificazioneEditTurni.vue";
import RsaPianificazioneEditOrario from "../../components/pianificazione/RsaPianificazioneEditOrario.vue";
import RsaPianificazioneEditOreAlternate from "../../components/pianificazione/RsaPianificazioneEditOreAlternate.vue";
import RsaPianificazioneEditGiorniAlternati from "../../components/pianificazione/RsaPianificazioneEditGiorniAlternati.vue";
import RsaPianificazioneEditGiorniMese from "../../components/pianificazione/RsaPianificazioneEditGiorniMese.vue";
import BancaFarmaciRicercaFarmacoComponent from "../../../bancafarmaci/components/BancaFarmaciRicercaFarmacoComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
	components: { DatePicker, RsaPianificazioneEditTurni, RsaPianificazioneEditOrario, RsaPianificazioneEditOreAlternate, RsaPianificazioneEditGiorniAlternati, RsaPianificazioneEditGiorniMese, BancaFarmaciRicercaFarmacoComponent, RsaPianificazioneEditAccessi },
	data() {
		const now = new Date();
		const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
		const minDate = new Date(today);
		return {
			pathResources: "/rsapazienteprescrizioni",
			customToolbar: [
				["bold", "italic", "underline", "strike"], // toggled buttons
				[{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
				[{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
				[{ indent: "-1" }, { indent: "+1" }], // outdent/indent
				[{ color: [] }, { background: [] }], // dropdown with defaults from theme
			],
			tabOrarioDisabled: false,
			tabTurniDisabled: false,
			tabOreAlternateDisabled: false,
			tabGiorniAlternatiDisabled: false,
			tabGiorniMeseDisabled: false,
			tabAccessiDisabled: false,
			btnDisabledAggiungiOrario: false,
			jsonData: { id: null, idAccettazione: null, idPaziente: null, idPosologia: null, tipoPrestazione: "FARMACOLOGICA", dataInizio: null, dataFine: null, codiceProdotto: null, atcGmp: null, prescrizione: null, quantita: 1, frequenza: null, costo: 0, stato: null, note: null },
			jsonDataAccettazione: null,
			posologiaOptions: [],
			filtroFarmaci: { descrizione: "" },
			activeTabIndex: 0,
			attivitaOptions: [],
			unitaMisureOptions: [
				{ text: "---", value: null },
				{ text: "Unità", value: "UN" },
				{ text: "Grammi", value: "GR" },
				{ text: "Gocce", value: "GTT" },
				{ text: "Milligrammi", value: "MG" },
				{ text: "Millilitri", value: "ML" },
			],
			min: minDate,
			jsonDataParams: { formaFarmaceutica: null, listaOrari: [], quantita: 0.0 },
			doseFarmaco: null,
			disabeConferma: false,
			pianificazione: {},
			listaOrari: [],
		};
	},
	watch: {},
	methods: {
		show(jsonDataAccettazione, prescrizione) {
			let me = this;
			me.jsonDataAccettazione = jsonDataAccettazione;
			me.jsonData = prescrizione;
			me.jsonDataParams = JSON.parse(me.jsonData.params);
			this.$refs.mdlRsaPazientePrescrizioneFarmacoEditModalComponent.show();
		},
		onOk(bvModalEvent) {
			let me = this;
			me.jsonData.quantita = this.jsonDataParams.quantita;
			this.jsonDataParams.listaOrari = this.listaOrari;
			me.jsonData.params = JSON.stringify(this.jsonDataParams);
			bvModalEvent.preventDefault();
			me.salva();
		},
		onShown() {
			let me = this;
			me.disabeConferma = false;
			me.pianificazione = {};
			me.listaOrari = [];
			if (this.jsonDataParams.listaOrari.length > 0) {
				me.pianificazione = this.jsonDataParams.listaOrari[0];
			}
			me.$refs.cmpRsaPianificazioneEditGiorniMese.init(me.jsonData);
			me.$refs.cmpRsaPianificazioneEditGiorniAlternati.init(me.jsonData);
			me.$refs.cmpRsaPianificazioneEditAccessi.init(me.jsonData);
			switch (me.pianificazione.tipo) {
				case "TURNI":
					me.$refs.cmpRsaPianificazioneEditTurni.setPianificazione(me.pianificazione);
					me.activeTabIndex = 0;
					break;
				case "ORARIO":
					me.$refs.cmpRsaPianificazioneEditOrario.setPianificazione(me.pianificazione);
					me.activeTabIndex = 1;
					break;
				case "ORE ALTERNATE":
					me.$refs.cmpRsaPianificazioneEditOreAlternate.setPianificazione(me.pianificazione);
					me.activeTabIndex = 2;
					break;
				case "GIORNI ALTERNATI":
					me.$refs.cmpRsaPianificazioneEditGiorniAlternati.setPianificazione(me.jsonData, me.pianificazione);
					me.activeTabIndex = 3;
					break;
				case "GIORNI MESE":
					me.$refs.cmpRsaPianificazioneEditGiorniMese.setPianificazione(me.pianificazione);
					me.activeTabIndex = 4;
					break;
				case "ACCESSI":
					me.$refs.cmpRsaPianificazioneEditAccessi.setPianificazione(me.pianificazione);
					me.activeTabIndex = 5;
					break;
			}
		},
		onAfterMountedRsaPianificazioneEditTurni() { },
		onUpdatePianificazioneTurni(params) {
			this.listaOrari = [];
			this.listaOrari.push({ tipo: "TURNI", giorni: params.giorni, orari: params.orari, params: "{}" });
		},
		onAfterMountedRsaPianificazioneEditOrario() { },
		onUpdatePianificazioneOrario(params) {
			this.listaOrari = [];
			this.listaOrari.push({ tipo: "ORARIO", giorni: params.giorni, orari: params.orari, params: "{}" });
		},
		onAfterMountedRsaPianificazioneEditOreAlternate() { },
		onUpdatePianificazioneOreAlternate(params) {
			this.listaOrari = [];
			this.listaOrari.push({ tipo: "ORE ALTERNATE", giorni: params.giorni, orari: params.orari, params: JSON.stringify(params.params) });
		},
		onAfterMountedRsaPianificazioneEditGiorniAlternati() { },
		onUpdatePianificazioneGiorniAlternati(params) {
			this.listaOrari = [];
			this.listaOrari.push({ tipo: "GIORNI ALTERNATI", giorni: params.giorni, orari: params.orari, params: JSON.stringify(params.params) });
		},
		onAfterMountedRsaPianificazioneEditGiorniMese() { },
		onUpdatePianificazioneGiorniMese(params) {
			this.listaOrari = [];
			this.listaOrari.push({ tipo: "GIORNI MESE", giorni: params.giorni, orari: params.orari, params: JSON.stringify(params.params) });
		},
		onAfterMountedRsaPianificazioneEditAccessi() { },
		onUpdatePianificazioneAccessi(params) {
			console.log("update", params);
			this.listaOrari = [];
			this.listaOrari.push({ tipo: "ACCESSI", giorni: params.giorni, orari: "00:00", params: JSON.stringify(params.params) });
		},
		onClickOpenRicercaFarmaco() {
			let me = this;
			document.getElementById("boxSelezionaFarmaco").classList.remove("sa-bancafarmaci-hidden");
			document.getElementById("boxSelezionaFarmaco").classList.add("sa-bancafarmaci-visible");
			me.disabeConferma = true;
		},
		closeRicercaFarmaco() {
			let me = this;
			document.getElementById("boxSelezionaFarmaco").classList.remove("sa-bancafarmaci-visible");
			document.getElementById("boxSelezionaFarmaco").classList.add("sa-bancafarmaci-hidden");
			me.disabeConferma = false;
		},
		onConfermaSelezioneBancaFarmaciRicercaFarmacoComponent(schedaFarmaco) {
			this.schedaFarmaco = schedaFarmaco;
			this.jsonData.prescrizione = schedaFarmaco.descrizione;
			this.jsonData.codiceProdotto = schedaFarmaco.codiceProdotto;
			this.jsonData.atcGmp = schedaFarmaco.atcGmp;
			this.jsonData.costo = schedaFarmaco.euroPrezzo1;
			this.jsonDataParams.formaFarmaceutica = schedaFarmaco.formaFarmaceutica.descrizione;
			this.closeRicercaFarmaco();
		},
		onAnnullaSelezioneBancaFarmaciRicercaFarmacoComponent() {
			this.closeRicercaFarmaco();
		},
		salva() {
			UtilityMixin.methods.saveResource(this.pathResources, this.jsonData, this.salvaSuccess, this.salvaError);
		},
		salvaSuccess() {
			let messaggio = "Salvataggio avvenuto con successo";
			this.$bvToast.toast(messaggio, {
				title: "INFO",
				autoHideDelay: 5000,
				variant: "success",
			});
			this.$refs.mdlRsaPazientePrescrizioneFarmacoEditModalComponent.hide();
			this.$emit("afterSave");
		},
		salvaError(error) {
			let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
			this.$bvToast.toast(messaggio, {
				title: "ATTENZIONE",
				autoHideDelay: 5000,
				variant: "danger",
			});
		},
		onHideModal() {
			this.$emit("afterCloseModal");
		},
	},
};
</script>
<style></style>
